var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button-group',[_vm._t("s1"),_vm._l((_vm.authBtns),function(btn){return _c('el-button',{key:btn.code,attrs:{"type":"primary","size":"small"},nativeOn:{"click":function($event){return _vm.btnClick(btn.code)}}},[_vm._v(_vm._s(btn.name)+" ")])}),_vm._t("s2")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }